import React from "react";
import DriverDecompositionTable from "../investigations/components/DriverDecompositionTable";
import { fmtSignedMoney } from "../investigations/format";

export default function MoversDriversPanel({ drivers = [], deltaCost = 0, onDrill, scopeNote }) {
  const sorted = [...drivers].sort((a, b) => Math.abs(b.deltaCost || 0) - Math.abs(a.deltaCost || 0));
  const top = sorted[0];
  return (
    <div className="rounded-card border border-card-bd bg-card p-6 space-y-4">
      {scopeNote && (
        <div className="text-[12px] text-text-3">{scopeNote}</div>
      )}
      <div className="flex items-baseline justify-between">
        <div className="text-[14px] font-semibold text-text">Biggest movers &amp; drivers</div>
        <div className="text-[12px] tabular-nums text-text-3">net {fmtSignedMoney(deltaCost)}</div>
      </div>
      {sorted.length === 0 ? (
        <div className="text-text-3">No drivers with a material change.</div>
      ) : (
        // The biggest mover is the first row, highlighted (its own colour) but the same
        // width/bar/Δ/share as every other driver — no longer a separate pill.
        <div onClickCapture={(e) => {
          const row = e.target.closest?.("[data-driver-key]");
          if (!row) return;
          const key = row.getAttribute("data-driver-key");
          const driver = sorted.find((d) => String(d.key) === key);
          onDrill?.(key, driver?.label);
        }}>
          <DriverDecompositionTable drivers={sorted} highlightKey={top?.key} />
        </div>
      )}
    </div>
  );
}
